export default __webpack_public_path__ + "static/media/organized.ed6032dd.svg";